import { render, staticRenderFns } from "./InputsTextEditor.vue?vue&type=template&id=615e6b64"
import script from "./InputsTextEditor.vue?vue&type=script&lang=js"
export * from "./InputsTextEditor.vue?vue&type=script&lang=js"
import style0 from "./InputsTextEditor.vue?vue&type=style&index=0&id=615e6b64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports